import { useQuery } from '@tanstack/react-query';
import { fetchBlogArticleBySlug } from './blog-client';

export function useBlogArticleBySlug(slug: string) {
  return useQuery({
    queryKey: ['blog-article', slug],
    queryFn: () => fetchBlogArticleBySlug(slug),
    enabled: !!slug,
    staleTime: 60_000,
  });
}
